/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function($){
  const media = $(window).width();
  
  
  $(document).ready(function(){
    $('.Tabs .Accordion .accordion-title').click(function(){
      $(this).toggleClass('up');
      $(this).parent().find('.accordion-content').slideToggle();
    })

    $('.share-button').click(function(){
      const title = document.title;
      const url = window.location.href

      if (navigator.share) {
        navigator.share({
          title: title,
          url: url
        })
      }
    })
    if(media < 1007){
      $('.Product__Slideshow .flickity-slider img').click(function(){
        $('.Product__ActionList [data-action="open-product-zoom"]').trigger('click')
      })
    }
    
    
    



//     let touchstartX = 0
//     let touchendX = 0

//     const slider = document.querySelector('.pswp__container')

//     function handleGesture(e) {
//       if (touchendX < touchstartX){
// 		$(document).find('.pswp__button--next').trigger('click');
//       } 
//       if (touchendX > touchstartX){        
//         $(document).find('.pswp__button--prev').trigger('click');
//       } 
//     }

//     slider.addEventListener('touchstart', e => {
//       touchstartX = e.changedTouches[0].screenX
//       handleGesture()
//     })

//     slider.addEventListener('touchend', e => {
//       touchendX = e.changedTouches[0].screenX
//       handleGesture()
//     })


  })
  
  if($('.ColorSwatchList').length === 0){
    $('body').addClass('color--variants-not')
  }
}(jQuery))


$(document).ready(function() {
  console.log("calling---");
      if(window.location.href.indexOf("de-de") >= 0){
        //$('.Header__MainNav ul.HorizontalList--spacingExtraLoose li:last-child').remove();
        $('.se-cookies-text').text('Wir verwenden Cookies, um sicherzustellen, dass wir Ihnen das beste Erlebnis auf unserer Website bieten. Wenn Sie fortfahren, gehen wir davon aus, dass Sie dies verstanden haben.');
        $('#se-accept-cookies-checkbox').text('Akzeptieren');    
      }
 $('body').on('click', '.ColorSwatch__Radio', function() {
setTimeout(() => {
 let btnTxt = $('.ProductForm__AddToCart').text();
   if(btnTxt!="Add to cart" && btnTxt!="Add to Cart" ){
   $(".onlyleftcss").hide();
   }
   else{
   $(".onlyleftcss").show();
   }
}, "1000");
   
});
   
  
  });


//$('.Product__Slideshow').flickity({
//  asNavFor: '.Product__Slideshow',
//  wrapAround: true
//});
// $(document).ready(function(){
	
// 	console.log('transformset');
//       var current_pull = parseInt($('.flickity-slider').css('transform').split(',')[4]);
//   if (!$('.body.template-product .flickity-slider').hasClass("Product__SlideItem--video")) {
//     console.log('addtransformclass');
// 	$('.body.template-product .flickity-slider').addClass('addtransformclass');
//   }  
//       console.log('current_pull:',current_pull);

// });